<template>
  <div class="admin-nav-secondary">
    <div v-if="$route.path.includes('addons')">
      <router-link to="/addons/available" :class="nav_link_includes('addons/available')">
        Available
      </router-link>
      <router-link to="/addons/upcoming" :class="nav_link_includes('addons/upcoming')">
        Upcoming
      </router-link>
    </div>
    <div v-if="$route.path.includes('calendar')">
      <router-link to="/calendar/settings" :class="nav_link_includes('calendar/settings')">
        Settings
      </router-link>
    </div>
    <div v-if="$route.path.includes('chores')">
      <router-link to="/chores/dashboard" :class="nav_link_includes('chores/dashboard')">
        Dashboard
      </router-link>
      <router-link to="/chores/today" :class="nav_link_includes('chores/today')">
        Today
      </router-link>
      <router-link to="/chores/upcoming" :class="nav_link_includes('chores/upcoming')">
        Upcoming
      </router-link>
      <router-link to="/chores/completed" :class="nav_link_includes('chores/completed')">
        Completed
      </router-link>
    </div>
    <div v-if="$route.path.includes('communicate')">
      <router-link to="/communicate/chat" :class="nav_link_includes('communicate/chat')">
        Chat
      </router-link>
      <router-link to="/communicate/messages" :class="nav_link_includes('communicate/messages')">
        Messages
      </router-link>
    </div>
    <div v-if="$route.path.includes('contacts')">
      <router-link to="/contacts/emergency" :class="nav_link_includes('contacts/emergency')">
        Emergency
      </router-link>
      <router-link to="/contacts/family" :class="nav_link_includes('contacts/family')">
        Family
      </router-link>
      <router-link to="/contacts/vendors" :class="nav_link_includes('contacts/vendors')">
        Vendors
      </router-link>
    </div>
    <div v-if="$route.path.includes('finance')">
      <router-link to="/finance/budget" :class="nav_link_includes('finance/budget')">
        Budget
      </router-link>
      <router-link to="/finance/bills" :class="nav_link_includes('finance/bills')">
        Bills
      </router-link>
      <router-link to="/finance/taxes" :class="nav_link_includes('finance/taxes')">
        Taxes
      </router-link>
      <router-link to="/finance/savings" :class="nav_link_includes('finance/savings')">
        Savings
      </router-link>
    </div>
    <div v-if="$route.path.includes('maintenance')">
      <router-link to="/maintenance/schedule" :class="nav_link_includes('maintenance/schedule')">
        Schedule
      </router-link>
      <router-link to="/maintenance/log" :class="nav_link_includes('maintenance/log')">
        Log
      </router-link>
    </div>
    <div v-if="$route.path.includes('manage')">
      <router-link to="/manage/dashboard" :class="nav_link_includes('manage/dashboard')">
        Dashboard
      </router-link>
      <router-link to="/manage/members" :class="nav_link_includes('manage/members')">
        Household Members
      </router-link>
      <router-link to="/manage/rooms" :class="nav_link_includes('manage/rooms')">
        Rooms
      </router-link>
    </div>
    <div v-if="$route.path.includes('meals')">
      <router-link to="/meals/planner" :class="nav_link_includes('meals/planner')">
        Planner
      </router-link>
      <router-link to="/meals/inventory" :class="nav_link_includes('meals/inventory')">
        Inventory
      </router-link>
      <router-link to="/meals/recipes" :class="nav_link_includes('meals/recipes')">
        Recipes
      </router-link>
    </div>
    <div v-if="$route.path.includes('setup')">
      <router-link to="/setup/basic" :class="nav_link_includes('setup/basic')">
        Basic Setup
      </router-link>
      <router-link to="/setup/features" :class="nav_link_includes('setup/features')">
        Features
      </router-link>
    </div>
    <div v-if="$route.path.includes('vault')">
      <router-link to="/vault/documents" :class="nav_link_includes('vault/documents')">
        Documents
      </router-link>
      <router-link to="/vault/passwords" :class="nav_link_includes('vault/passwords')">
        Passwords
      </router-link>
      <router-link to="/vault/cards" :class="nav_link_includes('vault/cards')">
        Credit &amp; Gift Cards
      </router-link>
    </div>

    <div class="admin-footer">
      &copy; WeLike, LLC
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

@Component
class SecondaryNavigation extends Vue {
  nav_link_includes(path) {
    return [this.$route.path.includes(path) ? 'active' : '', 'admin-nav-secondary-link'];
  }
}
export default SecondaryNavigation;
</script>

<style scoped>
.admin-nav-secondary {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  background-color: #45495b;
  box-shadow: inset -12px 0 10px -12px rgba(25, 29, 47, .5);
}

.admin-nav-secondary-link {
  display: block;
  padding: .75rem .5rem .75rem 1rem;
  font-size: .875rem;
  letter-spacing: .05em;
  color: #a0a4b6;
  background-color: #45495b;
  box-shadow: inset -12px 0 10px -12px rgba(25, 29, 47, .5);
  border-left: 6px solid transparent;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.admin-nav-secondary-link:first-child {
  padding-top: 1.5rem;
}

.admin-nav-secondary-link:hover, .admin-nav-secondary-link:hover {
  color: #cdd1e3;
  background-color: #45495b;
  text-decoration: none;
}

.admin-nav-secondary-link.active {
  background-color: #5c6072;
  color: #fff;
  border-left: 6px solid #207abb;
  border-left-color: #FF6633;
}
</style>
